import type {NavigationGuardWithThis} from 'vue-router';
import {EcommerceSalesChannels} from '@myparcel-frontend/types';

const validEcommercePlatforms = Object.values(EcommerceSalesChannels).map((platform) => platform.toLowerCase());

export const ecommercePlatformGuard: NavigationGuardWithThis<undefined> = (to) => {
  const {ecommercePlatform, shopId} = to.params as {
    ecommercePlatform: string;
    shopId: string;
    salesChannelId: string;
  };

  const sanitizedPlatform = ecommercePlatform.toLowerCase();

  // Redirect if the platform is not valid.
  if (!validEcommercePlatforms.includes(sanitizedPlatform)) {
    return {
      name: 'sales-channels',
      params: {shopId},
      replace: true,
    };
  }

  // Redirect if the platform in the URL needs to be updated.
  if (sanitizedPlatform !== ecommercePlatform) {
    return {
      ...to,
      params: {...to.params, ecommercePlatform: sanitizedPlatform},
      replace: true,
    };
  }

  // Store the uppercase version in the params for use in the application.
  to.params.ecommercePlatform = sanitizedPlatform.toUpperCase();

  return true;
};
